import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/spark-home/components/BentoMosaic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Header.tsx");
